<template>
	<div class='knd-paragraaf knd-paragraaf-byline swiper-no-swiping'>
		Gecheckt door 
		<span v-for='(author, index) in byline' :key="'author-' + index">
			<span v-if="index >= 1"> en </span>
			<a :href="author.contact" target="_blank">{{author.name}}</a>
		</span>
	</div>
</template>

<script>

	const vueObject = {
		props: ['byline'],
		methods: {}
	}

	export default vueObject;
</script>